export default "__VITE_ASSET__B6wpk8Fq__"